import * as THREE from "three"
import { getOrientation, degToRad } from "../../../utils"
import alphaMapImg from "../../../3d/flooralphamap.png"
import { BufferGeometryUtils } from "three/examples/jsm/utils/BufferGeometryUtils.js"
import floor from "../../../3d/floor2.jpg"
// import fxaa from "glsl-fxaa/fxaa.glsl"

let config = {
  reflectorSize: 512, // power 2 Less = more performance,
  blurIterations: 8,
  grainEffect: 0.15, // from 0.01 to 0.99 // WHole numbers may break it
}

export const getViewSizeAtDepth = function(depth = 0, camera = this.camera) {
  const fovInRadians = (camera.fov * Math.PI) / 180
  const height = Math.abs(
    (camera.position.z - depth) * Math.tan(fovInRadians / 2) * 2
  )
  return { width: height * camera.aspect, height }
}

export const createStaticWall = texture => {
  let geometry = new THREE.PlaneBufferGeometry(4, 1)
  let top = new THREE.PlaneBufferGeometry(9, 1)
  top.translate(0, 1, 0)
  let right = geometry.clone()
  right.translate(0.5, 0, 0)
  let left = geometry.clone()
  left.translate(-0.5, 0, 0)
  let geometries = [top, right, left]

  let merged = BufferGeometryUtils.mergeBufferGeometries(geometries)
  let material = new THREE.MeshPhongMaterial({
    side: THREE.DoubleSide,
    color: 0x000000,
    transparent: true,
    opacity: 0,
    dithering: true
    // map: texture,
  })

  //    new THREE.MeshPhongMaterial({
  //       color: 0x808080,
  //       side: THREE.DoubleSide,
  //     })
  let mesh = new THREE.Mesh(merged, material)
  mesh.receiveShadow = false
  return mesh
}
export const createScreen = texture => {
  let geometry = new THREE.PlaneBufferGeometry(1, 1)

  let material = new THREE.MeshPhongMaterial({
    side: THREE.DoubleSide,
    color: 0xffffff,
    transparent: true,
    opacity: 0,
    dithering: true,
    // roughness: 1,
    // metalness: 0,
    // relfectivity: 0,

    // shininess: 100,
    map: texture,
  })

  //    new THREE.MeshPhongMaterial({
  //       color: 0x808080,
  //       side: THREE.DoubleSide,
  //     })
  let mesh = new THREE.Mesh(geometry, material)
  
  mesh.receiveShadow = true
  return mesh
}

export const createFloor = () => {
  var geometry = new THREE.PlaneGeometry(1, 1, 20, 20)
  //   var material = new THREE.MeshStandardMaterial({
  //     side: THREE.DoubleSide,
  //     map: texture,
  //     alphaMap: alphaMap,
  //   })
  let mesh = new Reflector(geometry, {
    textureWidth: config.reflectorSize,
    textureHeight: config.reflectorSize,
    color: 0x889999,
    recursion: 1,
    dithering: true,
    
  })

  //   material.alphaMap.magFilter = THREE.NearestFilter
  //   material.alphaMap.wrapT = THREE.RepeatWrapping
  //   material.alphaMap.repeat.y = 1
  //   return new THREE.Mesh(geometry, material)
  return mesh
}
export const getScreenSize = (screenWidth, screenHeight, ratio) => {
  let orientation = getOrientation(screenWidth, screenHeight)
  let width, height
  if (orientation == "landscape") {
    height = screenHeight * 0.6
    width = height * ratio
  } else {
    width = screenWidth - 40
    height = width / ratio
  }

  return { width, height }
}
export const resizeScreen = (mesh, width, height, ratio) => {
  var orientation = getOrientation(width, height)
  var width, height
  if (orientation == "landscape") {
    height = height * 0.6
    width = height * ratio
  } else {
    width = width - 40
    height = width / ratio
  }
  //   mesh.scale.set(width, height, 1000)
}

let postprocess = material => {}
export const setTransparency = mesh => {
  mesh.material.transparent = true
  mesh.material.opacity = 1
}

export const createCubeCamera = () => {
  const cubeCamera = new THREE.CubeCamera(1, 500, 516)

  cubeCamera.position.set(0, -400, 4000)
  return cubeCamera
}
let blur2D = `
vec4 blur2D(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {
  vec4 color = vec4(0.0);
  vec2 off1 = vec2(1.411764705882353) * direction;
  vec2 off2 = vec2(3.2941176470588234) * direction;
  vec2 off3 = vec2(5.176470588235294) * direction;
  color += texture2D(image, uv) * 0.1964825501511404;
  color += texture2D(image, uv + (off1 / resolution)) * 0.2969069646728344;
  color += texture2D(image, uv - (off1 / resolution)) * 0.2969069646728344;
  color += texture2D(image, uv + (off2 / resolution)) * 0.09447039785044732;
  color += texture2D(image, uv - (off2 / resolution)) * 0.09447039785044732;
  color += texture2D(image, uv + (off3 / resolution)) * 0.010381362401148057;
  color += texture2D(image, uv - (off3 / resolution)) * 0.010381362401148057;
  return color;
}
`
/**

https://stackoverflow.com/questions/45625986/three-js-gaussian-blur-in-glsl-shader
https://threejsfundamentals.org/threejs/lessons/threejs-post-processing.html
https://github.com/Jam3/glsl-fast-gaussian-blur/blob/master/13.glsl
https://github.com/vanruesc/postprocessing/blob/master/src/passes/BlurPass.js
https://github.com/vanruesc/postprocessing/blob/a83c7b76b69cb8944bbde4cdffcdbff3065017dc/src/passes/Pass.js
https://github.com/vanruesc/postprocessing/blob/a83c7b76b69cb8944bbde4cdffcdbff3065017dc/src/passes/SavePass.js
https://github.com/vanruesc/postprocessing/blob/a83c7b76b69cb8944bbde4cdffcdbff3065017dc/src/passes/RenderPass.js
https://github.com/vanruesc/postprocessing/blob/a83c7b76b69cb8944bbde4cdffcdbff3065017dc/src/core/EffectComposer.js
https://github.com/mrdoob/three.js/blob/cf6f798d45d19bfc9f75fca00b130890c7941be6/examples/jsm/objects/Reflector.js
https://jsfiddle.net/f2Lommf5/12004/
https://stackoverflow.com/questions/28818410/blur-mirror-shader
https://discourse.threejs.org/t/creating-a-fading-reflection/3831
 */
export const Reflector = function(geometry, options) {
  THREE.Mesh.call(this, geometry)

  this.type = "Reflector"

  var scope = this

  options = options || {}

  var color =
    options.color !== undefined
      ? new THREE.Color(options.color)
      : new THREE.Color(0x7f7f7f)
  var textureWidth = options.textureWidth || 512
  var textureHeight = options.textureHeight || 512
  var clipBias = options.clipBias || 0
  var shader = options.shader || Reflector.ReflectorShader
  var recursion = options.recursion !== undefined ? options.recursion : 0

  //

  var reflectorPlane = new THREE.Plane()
  var normal = new THREE.Vector3()
  var reflectorWorldPosition = new THREE.Vector3()
  var cameraWorldPosition = new THREE.Vector3()
  var rotationMatrix = new THREE.Matrix4()
  var lookAtPosition = new THREE.Vector3(0, 0, -1)
  var clipPlane = new THREE.Vector4()
  var viewport = new THREE.Vector4()

  var view = new THREE.Vector3()
  var target = new THREE.Vector3()
  var q = new THREE.Vector4()

  var textureMatrix = new THREE.Matrix4()
  var virtualCamera = new THREE.PerspectiveCamera()

  var parameters = {
    minFilter: THREE.LinearFilter,
    magFilter: THREE.LinearFilter,
    format: THREE.RGBFormat,
    stencilBuffer: false,
  }

  var renderTarget = new THREE.WebGLRenderTarget(
    textureWidth,
    textureHeight,
    parameters
  )

  let postReadTarget = new THREE.WebGLRenderTarget(
    textureWidth,
    textureHeight,
    parameters
  )
  let postWriteTarget = new THREE.WebGLRenderTarget(
    textureWidth,
    textureHeight,
    parameters
  )

  let postRenderTarget = new THREE.WebGLRenderTarget(
    textureWidth,
    textureHeight,
    parameters
  )

  let loader = new THREE.TextureLoader()
  let tFloor = loader.load(floor)

  renderTarget.depthBuffer = true
  renderTarget.depthTexture = new THREE.DepthTexture()
  renderTarget.depthTexture.type = THREE.UnsignedShortType
  if (
    !THREE.Math.isPowerOfTwo(textureWidth) ||
    !THREE.Math.isPowerOfTwo(textureHeight)
  ) {
    renderTarget.texture.generateMipmaps = false
  }
  renderTarget.texture.magFilter = THREE.LinearFilter
  //   renderTarget.texture.minFilter = THREE.LinearMipMapLinearFilter

  var material = new THREE.ShaderMaterial({
    uniforms: {
      ...THREE.UniformsUtils.clone(shader.uniforms),
      tFloor: new THREE.Uniform(tFloor),
      uOpacity: new THREE.Uniform(0),
    },
    fragmentShader: shader.fragmentShader,
    vertexShader: shader.vertexShader,
    transparent: true,
  })

  material.uniforms.tDiffuse.value = renderTarget.texture
  material.uniforms.tDepth.value = renderTarget.depthTexture
  material.uniforms.tPostTexture = new THREE.Uniform(postReadTarget.texture)
  material.uniforms.color.value = color
  material.uniforms.textureMatrix.value = textureMatrix

  this.material = material
  this.renderOrder = -Infinity // render first
  //   let clock = new THREE.Clock()

  let postCamera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1)
  let postScene = new THREE.Scene()
  postScene.background = new THREE.Color(0x00ff00)

  let postMaterial = new THREE.MeshBasicMaterial({
    color: 0xff0000,
    map: renderTarget.texture,
  })
  postMaterial = new THREE.ShaderMaterial({
    uniforms: {
      uMap: new THREE.Uniform(null),
      // For the UVs to sample correctly. We need to multiply them by the texture matrix
      uvTransform: new THREE.Uniform(
        new THREE.Matrix3().copy(renderTarget.texture.matrix)
      ),
      uDirection: new THREE.Uniform(new THREE.Vector2(1, 0)),
    },
    vertexShader: `
              uniform mat3 uvTransform;
            varying vec2 vUv;
            void main(){
                gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.);
                vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
            }`,

    fragmentShader: `
            varying vec2 vUv;
            uniform sampler2D uMap;
            uniform vec2 uDirection;
            ${blur2D}
              void main(){
                  vec3 color = vec3(1.);
                  color = blur2D(uMap, vUv, vec2(${config.reflectorSize}.), uDirection).rgb;

                //   color = vec3(1. - vUv.x);

                  gl_FragColor = vec4(color, 1.);
              }
            `,
    color: 0xff0000,
    map: renderTarget.texture,
  })

  /**


   */

  let testGeo = new THREE.PlaneBufferGeometry(10, 10)
  testGeo = getFullscreenTriangle()

  let fullScreenMesh = new THREE.Mesh(testGeo, postMaterial)
  fullScreenMesh.frustumCulled = false
  postScene.add(fullScreenMesh)

  this.onBeforeRender = function(renderer, scene, camera) {
    if ("recursion" in camera.userData) {
      if (camera.userData.recursion === recursion) return

      camera.userData.recursion++
    }

    reflectorWorldPosition.setFromMatrixPosition(scope.matrixWorld)
    cameraWorldPosition.setFromMatrixPosition(camera.matrixWorld)

    rotationMatrix.extractRotation(scope.matrixWorld)

    normal.set(0, 0, 1)
    normal.applyMatrix4(rotationMatrix)

    view.subVectors(reflectorWorldPosition, cameraWorldPosition)

    // Avoid rendering when reflector is facing away

    if (view.dot(normal) > 0) return

    view.reflect(normal).negate()
    view.add(reflectorWorldPosition)

    rotationMatrix.extractRotation(camera.matrixWorld)

    lookAtPosition.set(0, 0, -1)
    lookAtPosition.applyMatrix4(rotationMatrix)
    lookAtPosition.add(cameraWorldPosition)

    target.subVectors(reflectorWorldPosition, lookAtPosition)
    target.reflect(normal).negate()
    target.add(reflectorWorldPosition)

    virtualCamera.position.copy(view)
    virtualCamera.up.set(0, 1, 0)
    virtualCamera.up.applyMatrix4(rotationMatrix)
    virtualCamera.up.reflect(normal)
    virtualCamera.lookAt(target)

    virtualCamera.far = camera.far // Used in WebGLBackground

    virtualCamera.updateMatrixWorld()
    virtualCamera.projectionMatrix.copy(camera.projectionMatrix)

    virtualCamera.userData.recursion = 2

    this.material.uniforms.cameraNear.value = camera.near
    this.material.uniforms.cameraFar.value = camera.far

    // Update the texture matrix
    textureMatrix.set(
      0.5,
      0.0,
      0.0,
      0.5,
      0.0,
      0.5,
      0.0,
      0.5,
      0.0,
      0.0,
      0.5,
      0.5,
      0.0,
      0.0,
      0.0,
      1.0
    )
    textureMatrix.multiply(virtualCamera.projectionMatrix)
    textureMatrix.multiply(virtualCamera.matrixWorldInverse)
    textureMatrix.multiply(scope.matrixWorld)

    // Now update projection matrix with new clip plane, implementing code from: http://www.terathon.com/code/oblique.html
    // Paper explaining this technique: http://www.terathon.com/lengyel/Lengyel-Oblique.pdf
    reflectorPlane.setFromNormalAndCoplanarPoint(normal, reflectorWorldPosition)
    reflectorPlane.applyMatrix4(virtualCamera.matrixWorldInverse)

    clipPlane.set(
      reflectorPlane.normal.x,
      reflectorPlane.normal.y,
      reflectorPlane.normal.z,
      reflectorPlane.constant
    )

    var projectionMatrix = virtualCamera.projectionMatrix

    q.x =
      (Math.sign(clipPlane.x) + projectionMatrix.elements[8]) /
      projectionMatrix.elements[0]
    q.y =
      (Math.sign(clipPlane.y) + projectionMatrix.elements[9]) /
      projectionMatrix.elements[5]
    q.z = -1.0
    q.w = (1.0 + projectionMatrix.elements[10]) / projectionMatrix.elements[14]

    // Calculate the scaled plane vector
    clipPlane.multiplyScalar(2.0 / clipPlane.dot(q))

    // Replacing the third row of the projection matrix
    projectionMatrix.elements[2] = clipPlane.x
    projectionMatrix.elements[6] = clipPlane.y
    projectionMatrix.elements[10] = clipPlane.z + 1.0 - clipBias
    projectionMatrix.elements[14] = clipPlane.w

    // Render

    scope.visible = false

    var currentRenderTarget = renderer.getRenderTarget()

    var currentVrEnabled = renderer.xr.enabled
    var currentShadowAutoUpdate = renderer.shadowMap.autoUpdate

    renderer.xr.enabled = false // Avoid camera modification and recursion
    renderer.shadowMap.autoUpdate = false // Avoid re-computing shadows

    // renrerer
    renderer.setRenderTarget(renderTarget)
    renderer.render(scene, virtualCamera)

    // postMaterial.uniforms.uvTransform.value.copy(renderTarget.texture.matrix)

    // Read from original.
    // Then, output with blur
    // Then read from that output

    // postMaterial.uniforms.uMap.value = renderTarget.texture
    // renderer.setRenderTarget(postWriteTarget)
    // renderer.render(postScene, postCamera)

    let blurIterations = config.blurIterations
    for (let i = 0; i < blurIterations; i++) {
      if (i === 0) {
        // Initial step;
        postMaterial.uniforms.uMap.value = renderTarget.texture
      } else {
        postMaterial.uniforms.uMap.value = postReadTarget.texture
      }

      let radius = (blurIterations - i - 1) * 0.5
      postMaterial.uniforms.uDirection.value.set(
        i % 2 === 0 ? radius : 0,
        i % 2 === 0 ? 0 : radius
      )

      renderer.setRenderTarget(postWriteTarget)
      renderer.render(postScene, postCamera)
      // Swap Buffers
      let temp = postReadTarget
      postReadTarget = postWriteTarget
      postWriteTarget = temp
    }

    // renderer.setRenderTarget(postRenderTarget)
    // renderer.render(postScene, postCamera)

    // let composer = new EffectComposer(renderer)
    // renderer.autoClear = true
    // let renderPass = new RenderPass(scene, virtualCamera)
    // let savePass = new SavePass(renderTarget)
    // renderPass.renderToScreen = false
    // savePass.renderToScreen = false
    // // composer.addPass(renderPass)
    // composer.addPass(savePass)
    // composer.render(clock.getDelta())

    renderer.xr.enabled = currentVrEnabled
    renderer.shadowMap.autoUpdate = currentShadowAutoUpdate

    renderer.setRenderTarget(currentRenderTarget)

    // Restore viewport

    var bounds = camera.bounds

    if (bounds !== undefined) {
      var size = renderer.getSize()
      var pixelRatio = renderer.getPixelRatio()

      viewport.x = bounds.x * size.width * pixelRatio
      viewport.y = bounds.y * size.height * pixelRatio
      viewport.z = bounds.z * size.width * pixelRatio
      viewport.w = bounds.w * size.height * pixelRatio

      renderer.state.viewport(viewport)
    }

    scope.visible = true
  }

  this.getRenderTarget = function() {
    return renderTarget
  }
}

Reflector.prototype = Object.create(THREE.Mesh.prototype)
Reflector.prototype.constructor = Reflector

Reflector.ReflectorShader = {
  uniforms: {
    color: {
      type: "c",
      value: null,
    },

    tDiffuse: {
      type: "t",
      value: null,
    },

    tDepth: {
      type: "t",
      value: null,
    },

    textureMatrix: {
      type: "m4",
      value: null,
    },

    cameraNear: {
      type: "f",
      value: 0,
    },

    cameraFar: {
      type: "f",
      value: 0,
    },
  },

  vertexShader: [
    "uniform mat4 textureMatrix;",
    "varying vec4 vUv;",
    "varying vec2 vUbis;",

    "void main() {",

    "	vUv = textureMatrix * vec4( position, 1.0 );",
    " vUbis = uv;",

    "	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",

    "}",
  ].join("\n"),

  fragmentShader: [
    "#include <packing>",
    "uniform vec3 color;",
    "uniform sampler2D tDiffuse;",
    "uniform sampler2D tPostTexture;",
    "uniform sampler2D tDepth;",
    "uniform sampler2D tFloor;",
    "uniform float cameraNear;",
    "uniform float uOpacity;",
    "uniform float cameraFar;",
    "varying vec4 vUv;",
    "varying vec2 vUbis;",

    "float blendOverlay( float base, float blend ) {",

    "	return( base < 0.5 ? ( 2.0 * base * blend ) : ( 1.0 - 2.0 * ( 1.0 - base ) * ( 1.0 - blend ) ) );",

    "}",

    "vec3 blendOverlay( vec3 base, vec3 blend ) {",

    "	return vec3( blendOverlay( base.r, blend.r ), blendOverlay( base.g, blend.g ), blendOverlay( base.b, blend.b ) );",

    "}",

    "float readDepth( sampler2D depthSampler, vec4 coord ) {",

    "	float fragCoordZ = texture2DProj( depthSampler, coord ).x;",
    "	float viewZ = perspectiveDepthToViewZ( fragCoordZ, cameraNear, cameraFar );",
    "	return viewZToOrthographicDepth( viewZ, cameraNear, cameraFar );",

    "}",
    `
vec4 blur2D(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {
  vec4 color = vec4(0.0);
  vec2 off1 = vec2(1.411764705882353) * direction;
  vec2 off2 = vec2(3.2941176470588234) * direction;
  vec2 off3 = vec2(5.176470588235294) * direction;
  color += texture2D(image, uv) * 0.1964825501511404;
  color += texture2D(image, uv + (off1 / resolution)) * 0.2969069646728344;
  color += texture2D(image, uv - (off1 / resolution)) * 0.2969069646728344;
  color += texture2D(image, uv + (off2 / resolution)) * 0.09447039785044732;
  color += texture2D(image, uv - (off2 / resolution)) * 0.09447039785044732;
  color += texture2D(image, uv + (off3 / resolution)) * 0.010381362401148057;
  color += texture2D(image, uv - (off3 / resolution)) * 0.010381362401148057;
  return color;
}
`,

    "void main() {",
    " vec2 uv2D= vec2 (vUv.s / vUv.q, vUv.t / vUv.q);",
    "	vec4 base = texture2D(tPostTexture, uv2D);",
    // "	vec4 base = texture2D( tDiffuse, uv2D);",
    " vec4 floor = texture2D(tFloor, vUbis * 1.);",
    "   float depth = readDepth( tDepth, vUv );",
    "	gl_FragColor = vec4( blendOverlay( base.rgb, color ), 1.0 - ( depth * 0.0 ) );",
    "	gl_FragColor = vec4( texture2D(tPostTexture, uv2D).rgb, 1.0 - ( depth * 7000.0 ));",
    "	gl_FragColor = vec4( mix(base.rgb, base.rgb * 0.2, floor.r), uOpacity );",

    "}",
  ].join("\n"),
}
function getFullscreenTriangle() {
  let geometry
  const vertices = new Float32Array([-1, -1, 0, 3, -1, 0, -1, 3, 0])
  const uvs = new Float32Array([0, 0, 2, 0, 0, 2])
  geometry = new THREE.BufferGeometry()

  // Added for backward compatibility (setAttribute was added in three r110).
  if (geometry.setAttribute !== undefined) {
    geometry.setAttribute("position", new THREE.BufferAttribute(vertices, 3))
    geometry.setAttribute("uv", new THREE.BufferAttribute(uvs, 2))
  } else {
    geometry.addAttribute("position", new THREE.BufferAttribute(vertices, 3))
    geometry.addAttribute("uv", new THREE.BufferAttribute(uvs, 2))
  }

  return geometry
}

export class Filmgrain {
  constructor(width, height) {
    let renderTarget = new THREE.WebGLRenderTarget(width, height)
    let scene = new THREE.Scene()
    let camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1)

    let geometry = getFullscreenTriangle()
    let material = new THREE.ShaderMaterial({
      uniforms: {
        tMap: new THREE.Uniform(renderTarget.texture),
        uResolution: new THREE.Uniform(new THREE.Vector2(width * window.devicePixelRatio, height * window.devicePixelRatio)),
        uTime: new THREE.Uniform(0),
      },
      vertexShader: `
      varying vec2 vUv;
      void main(){
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.);
        vUv = uv;
      }`,
      fragmentShader: `
      varying vec2 vUv;
      uniform sampler2D tMap;
      uniform vec2 uResolution;
      uniform float uTime;
      ${fxaa}
      
float rand(vec2 co){
		return fract(sin(dot(co.xy ,vec2(12.9898,78.233))) * 43758.5453);
		}
        void main(){
          vec4 color = vec4(1.);
          vec2 fragCoord = vUv * uResolution;
          color = fxaa(tMap, fragCoord, uResolution);
          float dx = rand( vUv + uTime );
        float nIntensity = ${config.grainEffect};
          vec3 cResult = color.rgb + color.rgb * clamp( 0.1 + dx, 0.0, 1.0 );
      cResult = color.rgb + clamp( nIntensity, 0.0,1.0 ) * ( cResult - color.rgb );

          gl_FragColor = vec4(cResult, color.a);
        }
      `,
    })
    let mesh = new THREE.Mesh(geometry, material)

    scene.add(mesh)

    this.material = material

    this.scene = scene
    this.camera = camera
    this.renderTarget = renderTarget
  }
  setSize(width, height) {
    this.renderTarget.setSize(width, height)
    this.material.uniforms.uResolution.value.set(width, height)
  }

  setTime(time) {
    this.material.uniforms.uTime.value = time
  }
}

let fxaa = `
/**
Basic FXAA implementation based on the code on geeks3d.com with the
modification that the texture2DLod stuff was removed since it's
unsupported by WebGL.
--
From:
https://github.com/mitsuhiko/webgl-meincraft
Copyright (c) 2011 by Armin Ronacher.
Some rights reserved.
Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are
met:
    * Redistributions of source code must retain the above copyright
      notice, this list of conditions and the following disclaimer.
    * Redistributions in binary form must reproduce the above
      copyright notice, this list of conditions and the following
      disclaimer in the documentation and/or other materials provided
      with the distribution.
    * The names of the contributors may not be used to endorse or
      promote products derived from this software without specific
      prior written permission.
THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
"AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

#ifndef FXAA_REDUCE_MIN
    #define FXAA_REDUCE_MIN   (1.0/ 128.0)
#endif
#ifndef FXAA_REDUCE_MUL
    #define FXAA_REDUCE_MUL   (1.0 / 8.0)
#endif
#ifndef FXAA_SPAN_MAX
    #define FXAA_SPAN_MAX     8.0
#endif

//optimized version for mobile, where dependent 
//texture reads can be a bottleneck
vec4 fxaa(sampler2D tex, vec2 fragCoord, vec2 resolution,
            vec2 v_rgbNW, vec2 v_rgbNE, 
            vec2 v_rgbSW, vec2 v_rgbSE, 
            vec2 v_rgbM) {
    vec4 color;
    mediump vec2 inverseVP = vec2(1.0 / resolution.x, 1.0 / resolution.y);
    vec3 rgbNW = texture2D(tex, v_rgbNW).xyz;
    vec3 rgbNE = texture2D(tex, v_rgbNE).xyz;
    vec3 rgbSW = texture2D(tex, v_rgbSW).xyz;
    vec3 rgbSE = texture2D(tex, v_rgbSE).xyz;
    vec4 texColor = texture2D(tex, v_rgbM);
    vec3 rgbM  = texColor.xyz;
    vec3 luma = vec3(0.299, 0.587, 0.114);
    float lumaNW = dot(rgbNW, luma);
    float lumaNE = dot(rgbNE, luma);
    float lumaSW = dot(rgbSW, luma);
    float lumaSE = dot(rgbSE, luma);
    float lumaM  = dot(rgbM,  luma);
    float lumaMin = min(lumaM, min(min(lumaNW, lumaNE), min(lumaSW, lumaSE)));
    float lumaMax = max(lumaM, max(max(lumaNW, lumaNE), max(lumaSW, lumaSE)));
    
    mediump vec2 dir;
    dir.x = -((lumaNW + lumaNE) - (lumaSW + lumaSE));
    dir.y =  ((lumaNW + lumaSW) - (lumaNE + lumaSE));
    
    float dirReduce = max((lumaNW + lumaNE + lumaSW + lumaSE) *
                          (0.25 * FXAA_REDUCE_MUL), FXAA_REDUCE_MIN);
    
    float rcpDirMin = 1.0 / (min(abs(dir.x), abs(dir.y)) + dirReduce);
    dir = min(vec2(FXAA_SPAN_MAX, FXAA_SPAN_MAX),
              max(vec2(-FXAA_SPAN_MAX, -FXAA_SPAN_MAX),
              dir * rcpDirMin)) * inverseVP;
    
    vec3 rgbA = 0.5 * (
        texture2D(tex, fragCoord * inverseVP + dir * (1.0 / 3.0 - 0.5)).xyz +
        texture2D(tex, fragCoord * inverseVP + dir * (2.0 / 3.0 - 0.5)).xyz);
    vec3 rgbB = rgbA * 0.5 + 0.25 * (
        texture2D(tex, fragCoord * inverseVP + dir * -0.5).xyz +
        texture2D(tex, fragCoord * inverseVP + dir * 0.5).xyz);

    float lumaB = dot(rgbB, luma);
    if ((lumaB < lumaMin) || (lumaB > lumaMax))
        color = vec4(rgbA, texColor.a);
    else
        color = vec4(rgbB, texColor.a);
    return color;
}
void texcoords(vec2 fragCoord, vec2 resolution,
			out vec2 v_rgbNW, out vec2 v_rgbNE,
			out vec2 v_rgbSW, out vec2 v_rgbSE,
			out vec2 v_rgbM) {
	vec2 inverseVP = 1.0 / resolution.xy;
	v_rgbNW = (fragCoord + vec2(-1.0, -1.0)) * inverseVP;
	v_rgbNE = (fragCoord + vec2(1.0, -1.0)) * inverseVP;
	v_rgbSW = (fragCoord + vec2(-1.0, 1.0)) * inverseVP;
	v_rgbSE = (fragCoord + vec2(1.0, 1.0)) * inverseVP;
	v_rgbM = vec2(fragCoord * inverseVP);
}
vec4 fxaa(sampler2D tex, vec2 fragCoord, vec2 resolution) {
	mediump vec2 v_rgbNW;
	mediump vec2 v_rgbNE;
	mediump vec2 v_rgbSW;
	mediump vec2 v_rgbSE;
	mediump vec2 v_rgbM;

	//compute the texture coords
	texcoords(fragCoord, resolution, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);
	
	//compute FXAA
	return fxaa(tex, fragCoord, resolution, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);
}
`
